import { render, staticRenderFns } from "./GiveFeedbackLink.vue?vue&type=template&id=face940e&scoped=true&"
var script = {}
import style0 from "./GiveFeedbackLink.vue?vue&type=style&index=0&id=face940e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "face940e",
  null
  
)

export default component.exports